interface LogoProps {
  height?: number;
  className?: string;
}

/**
 * Doodi wordmark — inline SVG with the original brand colors baked in
 * (black wordmark + #FF4C6B heart accent).
 *
 * Inline (rather than `<img>`) so it can't be stretched by a parent
 * flexbox and so it renders pixel-crisp at any size without
 * downsampling artefacts. PNG exports are also produced at
 * `/public/doodi-logo.png` and `/public/doodi-logo@2x.png` for
 * off-site use (email, marketing, etc.).
 */
export default function Logo({ height = 32, className }: LogoProps) {
  const width = Math.round((height * 260) / 78);
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 260 78"
      role="img"
      aria-label="Doodi"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', flexShrink: 0 }}
    >
      <path
        d="M249.188 77.0781C243.938 77.0781 240.891 73.9375 240.891 68.4531V32.5C240.891 27.0625 243.938 23.875 249.188 23.875C254.391 23.875 257.484 27.0625 257.484 32.5V68.4531C257.484 73.9375 254.391 77.0781 249.188 77.0781Z"
        fill="#111111"
      />
      <path
        d="M200.109 76.75C187.406 76.75 179.766 66.8594 179.766 50.3594C179.766 34.0469 187.547 24.2031 200.297 24.2031C207.703 24.2031 213.328 28.2344 215.578 33.9531H215.906V15.9062C215.906 10.0938 219.328 7.28125 224.203 7.28125C229.078 7.28125 232.5 10.0938 232.5 15.9062V68.5469C232.5 74.3125 229.078 77.0781 224.203 77.0781C219.375 77.0781 215.906 74.3125 215.906 68.5469V67.0938H215.578C213.609 72.625 207.844 76.75 200.109 76.75ZM206.344 63.7656C212.344 63.7656 215.953 58.7969 215.953 50.5C215.953 42.2969 212.297 37.1875 206.344 37.1875C200.391 37.1875 196.781 42.2969 196.781 50.5C196.781 58.75 200.344 63.7656 206.344 63.7656Z"
        fill="#111111"
      />
      <path
        d="M148.781 77.2188C132.703 77.2188 122.672 67.4688 122.672 50.4531C122.672 33.7656 132.938 23.7344 148.781 23.7344C164.719 23.7344 174.891 33.7188 174.891 50.4531C174.891 67.5156 164.859 77.2188 148.781 77.2188ZM148.781 65.0312C154.453 65.0312 158.062 59.8281 158.062 50.5C158.062 41.3125 154.453 35.9219 148.781 35.9219C143.156 35.9219 139.547 41.3125 139.547 50.5C139.547 59.8281 143.062 65.0312 148.781 65.0312Z"
        fill="#111111"
      />
      <path
        d="M91.6875 77.2188C75.6094 77.2188 65.5781 67.4688 65.5781 50.4531C65.5781 33.7656 75.8438 23.7344 91.6875 23.7344C107.625 23.7344 117.797 33.7188 117.797 50.4531C117.797 67.5156 107.766 77.2188 91.6875 77.2188ZM91.6875 65.0312C97.3594 65.0312 100.969 59.8281 100.969 50.5C100.969 41.3125 97.3594 35.9219 91.6875 35.9219C86.0625 35.9219 82.4531 41.3125 82.4531 50.5C82.4531 59.8281 85.9688 65.0312 91.6875 65.0312Z"
        fill="#111111"
      />
      <path
        d="M8.625 76C3.1875 76 0 72.7188 0 67V17.3594C0 11.6406 3.1875 8.35938 8.625 8.35938H27.4688C47.9062 8.35938 59.9062 20.2188 59.9062 41.7812C59.9062 63.3906 47.8594 76 27.4688 76H8.625ZM17.2031 62.125H25.2188C36.4219 62.125 42.4219 55.3281 42.4219 41.8281C42.4219 29.125 36.0938 22.2344 25.2188 22.2344H17.2031V62.125Z"
        fill="#111111"
      />
      <path
        d="M249.384 20C248.973 20 248.349 19.6171 247.75 19.1959C242.434 15.6094 238.891 11.2699 238.891 6.9432C238.891 2.7441 241.773 0 245.055 0C247.126 0 248.548 1.16145 249.384 2.78239C250.233 1.14869 251.655 0 253.714 0C257.008 0 259.891 2.7441 259.891 6.9432C259.891 11.2699 256.334 15.6094 251.031 19.1959C250.42 19.6171 249.796 20 249.384 20Z"
        fill="#FF4C6B"
      />
    </svg>
  );
}
